import GT_logo from '../assets/svg/GT_logo.svg';
import GT_brand from '../assets/svg/GT_brand.svg';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

const Header = () => {
  const styles = {
    header: {
      height: { xs: '60px', sm: '80px', md: '140px' },
      alignItems: 'center',
      marginLeft: {
        xs: 'calc(2vw)',
        sm: 'calc(2vw)',
        md: 'calc(4vw)',
        lg: 'calc(3vw)',
      },
      paddingLeft: {
        xs: 'calc(2vw)',
        sm: 'calc(2vw)',
        md: 'calc(4vw)',
        lg: 'calc(2vw)',
      },
      marginRight: {
        xs: 'calc(1vw)',
        sm: 'calc(2vw)',
        md: 'calc(2vw)',
        lg: 'calc(6vw)',
      },
      paddingRight: {
        xs: 'calc(2vw)',
        sm: 'calc(2vw)',
        md: 'calc(2vw)',
        lg: 'calc(6vw)',
      },
    },
    logo: {
      marginTop: { xs: '1.5vh', sm: '1vh', md: '2vh' },
      marginBottom: { xs: '1vh', sm: '2vh' },
      justifyContent: { xs: 'left', sm: 'center' },
    },
    title: {
      typography: { xs: 'body2', sm: 'body1', md: 'h4' },
      marginTop: { xs: '0vh', sm: '-0.75vh', md: '0vh' },
      justifyContent: { xs: 'left', sm: 'center' },
      alignItems: 'center',
      display: 'flex',
    },
    titleContainer: {
      justifyContent: 'left',
      display: 'flex',
    },
  };

  return (
    <>
      <AppBar position="fixed" data-testid="header-test">
        <Toolbar disableGutters>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ md: 2 }}
            sx={styles.header}
          >
            <Grid item xs={1.5} sm={3} md={3.5} lg={3} xl={2.5}>
              <Stack direction="row" spacing={2} sx={styles.logo}>
                <img
                  src={GT_logo}
                  id="gt-logo"
                  alt="GT logo"
                  data-testid="gt-logo-test"
                />
                <img
                  src={GT_brand}
                  id="gt-brand"
                  alt="GroundTruth Inc."
                  data-testid="gt-brand-test"
                />
                <Divider
                  orientation="vertical"
                  variant="middle"
                  color="white"
                  id="divider"
                  flexItem
                />
              </Stack>
            </Grid>
            <Grid
              item
              xs={10}
              sm={9}
              md={8.5}
              lg={9}
              sx={styles.titleContainer}
            >
              <Typography
                id="app-title"
                className="App-title"
                sx={styles.title}
              >
                Audience-Based Direct Mail
              </Typography>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <Toolbar id="header-section" />
    </>
  );
};

export default Header;
